<div class="relative flex h-[60vh] min-h-[520px] items-center overflow-hidden bg-bg-base"
    style="background-image: url('/HOME.jfif'); background-size: cover; background-position: center;">
    <div class="absolute inset-0 bg-black/70"></div>
    <div class="absolute inset-0 bg-[radial-gradient(circle_at_top_right,var(--color-primary-soft),transparent_35%)]">
    </div>

    <div class="relative mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div style="opacity: 1; transform: none;">
            <div class="mb-4 flex items-center gap-3">
                <div
                    class="flex h-14 w-14 items-center justify-center rounded-xl border border-border-primary bg-primary-soft shadow-subtle backdrop-blur-sm">
                    <i class="fas fa-users text-2xl text-primary"></i>
                </div>
                <div>
                    <h1 class="h1 mb-1">{{ 'experts.header.title' | translate }}</h1>
                    <p class="body-large">{{ 'experts.header.subtitle' | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
